module.exports = __webpack_public_path__ + "images/luxe-1-927730d20fffcc937c4007d357ed2bdb.jpg";